module.exports = __webpack_public_path__ + "img/category-alchemy.2b28fb5c.svg";